import React from 'react';

const Twitter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill="#FFF">
        <g>
          <path
            d="M18.202 7.87s1.283-.093 1.798-.45c0 0-.123.41-1.668 1.708 0 0 .52 7.003-7.402 8.718 0 0-4.018.796-6.93-1.234 0 0 3.048.503 4.763-1.255 0 0-2.212.02-2.912-2.072 0 0 .835.167 1.332-.042 0 0-2.506-.481-2.46-3.013 0 0 .677.46 1.286.376 0 0-2.257-1.779-.858-3.996 0 0 3.024 3.315 6.772 3.118-.065-.237-.1-.486-.1-.743 0-1.648 1.442-2.985 3.22-2.985.899 0 1.712.342 2.296.892.429.007 1.31-.064 2.19-.648 0 0 .05.638-1.327 1.627z"
            transform="translate(-60 -694) translate(60 694)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Twitter;
